export default {
  to: "To: {{name}} <{{email}}>",

  attachment: {
    label: "Attachments: ",
    pdf: "{{number}}.pdf",
  },

  subject: {
    label: "Subject",
    value: "REMINDER INVOICE {{number}} | {{clientName}}"
  },

  dueDate: {
    label: "Reminder due date",
  },

  message: {
    label: "Message: ",
  },

  button: {
    send: "Send reminder",
    cancel: "Cancel",
  }
}
